import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-issue-cotract-brief-report',
  templateUrl: './issue-cotract-brief-report.component.html',
  styleUrls: ['./issue-cotract-brief-report.component.scss'],
})
export class IssueCotractBriefReportComponent implements OnInit {

  // contractData: any;
  startDate: any;
  endDate: any;
  repName: any;
  advtName: any;
  reportType: any; // ⬅️ Added this
  advtMonthwiseFormBeans: any[] = [];
  advtMonthwiseTotal: number = 0;
  offRepName: any;
  issueName: any;
  issueDates: any;

  constructor(
    private dialogRef: MatDialogRef<IssueCotractBriefReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toaster: ToastrService
  ) {
    // Accessing data passed from parent component
    // this.contractData = data.contractData;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.repName = data.repName;
    this.advtName = data.advtName;
    this.reportType = data.reportType; 
    this.issueName = data.issuename;
    this.issueDates = data.issueDates;
    this.offRepName = data.offRepName;

    // console.log('Contract Data:', this.contractData);
    console.log('Start Date:', this.startDate);
    console.log('End Date:', this.endDate);
    console.log('Rep Name:', this.repName);
    console.log('Advt Name:', this.advtName);
    console.log('Report Type:', this.reportType); // ✅ Print report type
  }

  ngOnInit(): void {
    const req = {
    req:{
      rep_name: this.repName,
      startDate: this.startDate,
      endDate: this.endDate,
      off_rep_name: this.offRepName,
      issue_name: this.issueName,
      issue_Date: this.issueDates
    }
    };

    this.service.getissueMonthwise(req).subscribe(
      (data: any) => {
        console.log("ADVT Data =", data);
        this.advtMonthwiseFormBeans = data;
        this.advtMonthwiseTotal = 0;

        for (let entry of this.advtMonthwiseFormBeans) {
          this.advtMonthwiseTotal += parseFloat(entry.rcv_amt) || 0;
        }
      },
      (error) => {
        console.error('Error fetching monthwise data:', error);
        this.toaster.error('Failed to load report data', 'Error');
      }
    );
  }
  exportExcel(fileName: string) {
    // Get the table element
    const element = document.getElementById('print-section');
    if (!element) {
      this.toaster.error('Table not found!');
      return;
    }
  
    // Use XLSX to convert the table to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Write workbook and save as Excel file
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}
